import React, { forwardRef } from 'react';
import classNames from 'classnames';

type ListboxOptionProps = {
  highlighted: boolean;
  children?: React.ReactNode;
};

export const ListboxOption = forwardRef<HTMLLIElement, ListboxOptionProps>(
  ({ highlighted, children, ...rest }, ref) => (
    <li
      ref={ref}
      className={classNames(
        'flex items-center cursor-default select-none relative px-3 py-2',
        {
          'bg-gray-100 text-gray-900': highlighted,
        }
      )}
      {...rest}
    >
      {children}
    </li>
  )
);
